import { useState, type FormEvent } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/da0rmr6th95mubjtuj70";

type Status = "idle" | "loading" | "success" | "error";

export default function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("已收到你的来信，我们会尽快回复！");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
      const spamHit = /spam/i.test(serverMsg) || /spam/i.test(responseText);

      if (res.ok && parsed?.code === "OK" && !spamHit) {
        setStatus("success");
        setMessage("已收到你的来信，我们会尽快回复！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg && serverMsg.trim() ? serverMsg : "发送失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  }

  return (
    <form id="contact-form" data-readdy-form="contact-form" onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="ct-name" className="mb-1.5 block text-sm font-medium text-foreground-800">你的称呼</label>
          <input
            id="ct-name"
            name="name"
            type="text"
            required
            placeholder="如何称呼你"
            className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
        <div>
          <label htmlFor="ct-email" className="mb-1.5 block text-sm font-medium text-foreground-800">联系邮箱</label>
          <input
            id="ct-email"
            name="email"
            type="email"
            required
            placeholder="name@example.com"
            className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
      </div>
      <input
        name="website_alt"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-honeypot"
      />
      <div>
        <label htmlFor="ct-msg" className="mb-1.5 block text-sm font-medium text-foreground-800">留言内容</label>
        <textarea
          id="ct-msg"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请写下你的建议、投稿或纠错反馈…"
          className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        ></textarea>
        <p className="mt-1 text-right text-xs text-secondary-400">最多 500 字</p>
      </div>
      <button
        type="submit"
        disabled={status === "loading"}
        className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:opacity-60"
      >
        {status === "loading" ? "发送中…" : "发送留言"}
      </button>
      {status === "success" && <p className="text-sm text-primary-700">{message}</p>}
      {status === "error" && <p className="text-sm text-primary-800">{message}</p>}
    </form>
  );
}